import React, { useEffect, useState } from "react";
import { ExternalLink, Check, X, Image as ImageIcon, Volume2 } from "lucide-react";
import { adminApi } from "@/admin/adminApi";
import { Skeleton } from "@/components/ui/skeleton";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function Personalizations() {
  const [items, setItems] = useState(null);
  useEffect(() => { adminApi.get("/personalizations").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);

  return (
    <div data-testid="admin-personalizations">
      <div className="mb-5"><h1 className="font-display text-2xl">Personalizations</h1><p className="text-sm text-wp-ink-muted">Private gift pages created by customers.</p></div>
      <div className="overflow-hidden rounded-wp-lg border border-border bg-card shadow-wp-soft">
        {items === null ? <div className="space-y-2 p-4">{[...Array(4)].map((_, i) => <Skeleton key={i} className="h-10 w-full" />)}</div>
          : items.length === 0 ? <div className="p-10 text-center text-wp-ink-muted">No gift pages yet.</div>
          : (
            <Table>
              <TableHeader><TableRow><TableHead>Recipient</TableHead><TableHead>Occasion</TableHead><TableHead>Photo</TableHead><TableHead>Voice</TableHead><TableHead>Message</TableHead><TableHead>Created</TableHead><TableHead className="text-right">Page</TableHead></TableRow></TableHeader>
              <TableBody>
                {items.map((p) => (
                  <TableRow key={p.id || p.token}>
                    <TableCell className="text-sm font-medium">{p.recipient_name || "—"}</TableCell>
                    <TableCell className="text-sm">{p.occasion || "—"}</TableCell>
                    <TableCell>{p.photo_asset_id ? <Check className="h-4 w-4 text-wp-success" /> : <X className="h-4 w-4 text-wp-ink-muted" />}</TableCell>
                    <TableCell>{p.voice_asset_id ? <Check className="h-4 w-4 text-wp-success" /> : <X className="h-4 w-4 text-wp-ink-muted" />}</TableCell>
                    <TableCell className="max-w-[220px]"><span className="line-clamp-1 text-sm text-wp-ink-muted">{p.ai_letter || p.gift_note || "—"}</span></TableCell>
                    <TableCell className="text-sm text-wp-ink-muted">{p.created_at ? new Date(p.created_at).toLocaleDateString() : "—"}</TableCell>
                    <TableCell className="text-right"><a href={`/gift/${p.token}`} target="_blank" rel="noreferrer" className="inline-grid h-8 w-8 place-items-center rounded-lg text-wp-rose-strong hover:bg-wp-blush-100"><ExternalLink className="h-4 w-4" /></a></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
      </div>
    </div>
  );
}
